import React, { useCallback } from 'react';

import ReportDateRange from '../../ReportDateRange';

interface Props {
  disabled?: boolean;
  startDate: Date | null;
  endDate: Date | null;
  onSetStartDate: (value: Date | null) => void;
  onSetEndDate: (value: Date | null) => void;
}
const MailedDatePicker: React.FC<Props> = ({
  disabled,
  startDate,
  endDate,
  onSetEndDate,
  onSetStartDate,
}) => {
  const handleChangeValues = useCallback(
    (value: [Date | null, Date | null]) => {
      if (value[0] === null) {
        onSetStartDate(null);
        onSetEndDate(null);
      } else {
        onSetStartDate(value[0]);
        onSetEndDate(value[1]);
      }
    },
    [onSetEndDate, onSetStartDate]
  );
  return (
    <ReportDateRange
      values={[startDate, endDate]}
      disabled={disabled}
      onChangeValues={handleChangeValues}
      prefix="Mailed date"
    />
  );
};

export default MailedDatePicker;
